import Component from "./CustomInputComponent";
export default Component;
